import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/feature'
import { auth } from './firebaseConfig.js'
import VueCookies from 'vue-cookies'

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
require('vue2-animate/dist/vue2-animate.min.css')

Vue.config.productionTip = false

Vue.use(VueCookies)


let app

auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App)
    }).$mount('#app')
  }
})
